<template>
  <DefaultLayout
    :steps-area-title="stepsAreaTitle"
    :steps="steps"
    :features-area-title="featuresAreaTitle"
    :features="features"
  >
    <div class="uploadAreaWrapper">
      <div class="uploadAreaContainer">
        <div class="uploadAreaTitle">{{ pageTitle }}</div>
        <div class="homePageContainer">
          <AsideNav :menus="menus" class="asideNav" />
          <UploadFile
            :accept="accept"
            :limit="limit"
            :multiple="false"
            @onExceed="onUploadExceed"
            @onSuccess="onUploadSuccess"
            v-if="files.length === 0"
            class="uploadFileComponent"
          />
          <div v-else class="fileListComponent">
            <div class="fileListContainer">
              <div class="cardTitleBox">
                <div class="title"></div>
                <div class="btnGroups">
                  <button class="btn" @click="handleReUpload">重新上传</button>
                </div>
              </div>
              <div class="cardMain">
                <div class="cardMainLeft">
                  <div class="imgBox">
                    <img :src="file.src" alt="" ref="cropperRef" class="img" />
                  </div>
                </div>
                <div class="cardMainRight">
                  <div class="control_panel_area no-scroller">
                    <div class="card">
                      <div class="card_title_box">
                        <span class="icon change_size_icon"></span>
                        <span class="title">调整尺寸</span>
                      </div>
                      <div class="card_container">
                        <div class="change_size_card_container">
                          <div class="size_box">
                            <div class="size_input">
                              <span class="title">宽</span>
                              <el-input
                                type="number"
                                class="input"
                                :controls="false"
                                v-model="width"
                                @focus="handleChangeSize"
                                @input.native="handleChangeWidth"
                              ></el-input>
                              <div class="unit_list_select">
                                <div class="unit_selected">
                                  {{ unit }}
                                  <!--                                    <svg class="icon" width="9" height="6" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                                  <!--                                      <path-->
                                  <!--                                              d="M3.7 4.933 1.2 1.6A1 1 0 0 1 2 0h5a1 1 0 0 1 .8 1.6L5.3 4.933a1 1 0 0 1-1.6 0Z"-->
                                  <!--                                              fill="currentColor"-->
                                  <!--                                      ></path>-->
                                  <!--                                    </svg>-->
                                </div>
                                <div class="unit_list">
                                  <div class="unit_item" @click="setPixelUnit('px')">px</div>
                                  <div class="unit_item" @click="setPixelUnit('mm')">mm</div>
                                  <div class="unit_item" @click="setPixelUnit('in')">in</div>
                                </div>
                              </div>
                            </div>
                            <div :style="{ visibility: !showConfirmBtn ? 'hidden' : 'visible' }">
                              <el-tooltip v-if="lock" content="取消锁定宽高比">
                                <span class="lock lock_false" @click="setLock(false)"></span>
                              </el-tooltip>
                              <el-tooltip content="锁定宽高比" v-else>
                                <span class="lock lock_true" @click="setLock(true)"></span>
                              </el-tooltip>
                            </div>

                            <div class="size_input">
                              <span class="title">高</span>
                              <el-input
                                type="number"
                                class="input"
                                :controls="false"
                                v-model="height"
                                @focus="handleChangeSize"
                                @input.native="handleChangeHeight"
                              ></el-input>
                              <div class="unit_list_select">
                                <div class="unit_selected">
                                  {{ unit }}
                                  <!--                                    <svg class="icon" width="9" height="6" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                                  <!--                                      <path-->
                                  <!--                                              d="M3.7 4.933 1.2 1.6A1 1 0 0 1 2 0h5a1 1 0 0 1 .8 1.6L5.3 4.933a1 1 0 0 1-1.6 0Z"-->
                                  <!--                                              fill="currentColor"-->
                                  <!--                                      ></path>-->
                                  <!--                                    </svg>-->
                                </div>
                                <div class="unit_list">
                                  <div class="unit_item" @click="setPixelUnit('px')">px</div>
                                  <div class="unit_item" @click="setPixelUnit('mm')">mm</div>
                                  <div class="unit_item" @click="setPixelUnit('in')">in</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="confirm_box" v-if="showConfirmBtn">
                            <button class="btn cancel_btn" @click="handleConfirm('cancel')">取消</button>
                            <button class="btn confirm_btn" @click="handleConfirm('confirm')">应用</button>
                          </div>
                          <div class="change_size_tab_container">
                            <div class="change_size_tab_box">
                              <div
                                :class="{ tab: true, active: this.currentSizeTab === CHANGE_SIZE_TAB.COMMON }"
                                @click="changeSizeTab(CHANGE_SIZE_TAB.COMMON)"
                              >
                                常规
                              </div>
                              <div
                                :class="{ tab: true, active: this.currentSizeTab === CHANGE_SIZE_TAB.CERTIFICATE }"
                                @click="changeSizeTab(CHANGE_SIZE_TAB.CERTIFICATE)"
                              >
                                证件
                              </div>
                              <!--                    <div-->
                              <!--                            :class="{ tab: true, active: this.currentSizeTab === CHANGE_SIZE_TAB.EC }"-->
                              <!--                            @click="changeSizeTab(CHANGE_SIZE_TAB.EC)"-->
                              <!--                    >-->
                              <!--                      电商-->
                              <!--                    </div>-->
                            </div>
                            <div
                              v-if="this.currentSizeTab === CHANGE_SIZE_TAB.COMMON"
                              class="change_size_tab_content common_tab_content"
                            >
                              <div class="common_size_list">
                                <div
                                  :class="{ common_size_item: true, active: ratio === 'free' }"
                                  @click="setRatio(0, 0, 'free')"
                                >
                                  <svg
                                    class="icon"
                                    width="18"
                                    height="15"
                                    viewBox="0 0 18 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.75"
                                      y="0.75"
                                      width="16.5"
                                      height="13.5"
                                      rx="2.25"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">自由尺寸</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === 'origin' }"
                                  @click="setRatio(0, 0, 'origin')"
                                >
                                  <svg
                                    class="icon"
                                    width="20"
                                    height="15"
                                    viewBox="0 0 20 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g id="Group 6">
                                      <rect
                                        id="Rectangle 327"
                                        x="0.75"
                                        y="0.75"
                                        width="18.5"
                                        height="13.5"
                                        rx="2.25"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                      />
                                      <rect
                                        id="Rectangle 328"
                                        x="0.75"
                                        y="6.75"
                                        width="10.5"
                                        height="7.5"
                                        rx="2.25"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                      />
                                    </g>
                                  </svg>
                                  <span class="txt">原比例</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === '1:1' }"
                                  @click="setRatio(1, 1, '1:1')"
                                >
                                  <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.75"
                                      y="0.75"
                                      width="15.5"
                                      height="15.5"
                                      rx="2.25"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">1:1</span>
                                </div>
                              </div>
                              <div class="common_size_list">
                                <div
                                  :class="{ common_size_item: true, active: ratio === '2:3' }"
                                  @click="setRatio(2, 3, '2:3')"
                                >
                                  <svg
                                    width="15"
                                    height="22"
                                    viewBox="0 0 15 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="13.75"
                                      y="20.75"
                                      width="12.5"
                                      height="19.5"
                                      rx="2.25"
                                      transform="rotate(-180 13.75 20.75)"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">2:3</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === '3:2' }"
                                  @click="setRatio(3, 2, '3:2')"
                                >
                                  <svg
                                    width="21"
                                    height="14"
                                    viewBox="0 0 21 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="20.25"
                                      y="0.75"
                                      width="12.5"
                                      height="19.5"
                                      rx="2.25"
                                      transform="rotate(90 20.25 0.75)"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">3:2</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === '3:4' }"
                                  @click="setRatio(3, 4, '3:4')"
                                >
                                  <svg
                                    width="15"
                                    height="18"
                                    viewBox="0 0 15 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.75"
                                      y="0.75"
                                      width="13.5"
                                      height="16.5"
                                      rx="2.25"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">3:4</span>
                                </div>
                              </div>
                              <div class="common_size_list">
                                <div
                                  :class="{ common_size_item: true, active: ratio === '4:3' }"
                                  @click="setRatio(4, 3, '4:3')"
                                >
                                  <svg
                                    width="19"
                                    height="16"
                                    viewBox="0 0 19 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="17.75"
                                      y="1.25"
                                      width="13.5"
                                      height="16.5"
                                      rx="2.25"
                                      transform="rotate(90 17.75 1.25)"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">4:3</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === '9:16' }"
                                  @click="setRatio(9, 16, '9:16')"
                                >
                                  <svg
                                    width="14"
                                    height="23"
                                    viewBox="0 0 14 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="12.75"
                                      y="21.75"
                                      width="11.5"
                                      height="20.5"
                                      rx="2.25"
                                      transform="rotate(-180 12.75 21.75)"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">9:16</span>
                                </div>
                                <div
                                  :class="{ common_size_item: true, active: ratio === '16:9' }"
                                  @click="setRatio(16, 9, '16:9')"
                                >
                                  <svg
                                    width="22"
                                    height="13"
                                    viewBox="0 0 22 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="21.25"
                                      y="0.75"
                                      width="11.5"
                                      height="20.5"
                                      rx="2.25"
                                      transform="rotate(90 21.25 0.75)"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                  <span class="txt">16:9</span>
                                </div>
                              </div>
                              <div class="common_size_list">
                                <div
                                  :class="{
                                    common_size_item: true,
                                    crop_to_edge: true,
                                    active: ratio === 'crop_to_edge'
                                  }"
                                  @click="setRatio(0, 0, 'crop_to_edge')"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g id="Group 7">
                                      <path
                                        id="Union"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M4.85714 6.51429C5.77236 6.51429 6.51429 5.77236 6.51429 4.85714C6.51429 3.94193 5.77236 3.2 4.85714 3.2C3.94193 3.2 3.2 3.94193 3.2 4.85714C3.2 5.77236 3.94193 6.51429 4.85714 6.51429ZM4.85714 7.71429C6.4351 7.71429 7.71429 6.4351 7.71429 4.85714C7.71429 4.72154 7.70484 4.58814 7.68657 4.45757C7.69513 4.51873 7.70175 4.58052 7.70638 4.64286H12.2936C12.2884 4.7136 12.2857 4.78506 12.2857 4.85714C12.2857 6.4351 13.5649 7.71429 15.1429 7.71429C15.2415 7.71429 15.3389 7.70929 15.435 7.69953C15.4091 7.70216 15.3832 7.70444 15.3571 7.70638V12.2936C15.2864 12.2884 15.2149 12.2857 15.1429 12.2857C13.5649 12.2857 12.2857 13.5649 12.2857 15.1429C12.2857 15.2149 12.2884 15.2864 12.2936 15.3571H7.70638C7.70444 15.3832 7.70216 15.4091 7.69953 15.435C7.70929 15.3389 7.71429 15.2415 7.71429 15.1429C7.71429 13.5649 6.4351 12.2857 4.85714 12.2857C4.78506 12.2857 4.7136 12.2884 4.64286 12.2936V7.70638C4.59432 7.70278 4.54611 7.69796 4.49828 7.69197C4.61583 7.7067 4.7356 7.71429 4.85714 7.71429ZM3.14767 7.14667C2.45096 6.62564 2 5.79405 2 4.85714C2 3.27919 3.27919 2 4.85714 2C5.7919 2 6.62181 2.44889 7.14307 3.14286H12.8569C13.3782 2.44889 14.2081 2 15.1429 2C16.7208 2 18 3.27919 18 4.85714C18 5.7919 17.5511 6.62181 16.8571 7.14307V12.8569C17.5511 13.3782 18 14.2081 18 15.1429C18 16.7208 16.7208 18 15.1429 18C14.2081 18 13.3782 17.5511 12.8569 16.8571H7.14307C6.62181 17.5511 5.7919 18 4.85714 18C3.27919 18 2 16.7208 2 15.1429C2 14.2081 2.44889 13.3782 3.14286 12.8569V7.14307C3.14446 7.14427 3.14606 7.14547 3.14767 7.14667ZM15.1429 6.51429C16.0581 6.51429 16.8 5.77236 16.8 4.85714C16.8 3.94193 16.0581 3.2 15.1429 3.2C14.2276 3.2 13.4857 3.94193 13.4857 4.85714C13.4857 5.77236 14.2276 6.51429 15.1429 6.51429ZM6.51429 15.1429C6.51429 16.0581 5.77236 16.8 4.85714 16.8C3.94193 16.8 3.2 16.0581 3.2 15.1429C3.2 14.2276 3.94193 13.4857 4.85714 13.4857C5.77236 13.4857 6.51429 14.2276 6.51429 15.1429ZM15.1429 16.8C16.0581 16.8 16.8 16.0581 16.8 15.1429C16.8 14.2276 16.0581 13.4857 15.1429 13.4857C14.2276 13.4857 13.4857 14.2276 13.4857 15.1429C13.4857 16.0581 14.2276 16.8 15.1429 16.8Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                  </svg>

                                  <span class="txt">裁剪到边缘</span>
                                </div>
                              </div>
                            </div>
                            <div
                              v-else-if="this.currentSizeTab === CHANGE_SIZE_TAB.CERTIFICATE"
                              class="change_size_tab_content certificate_tab_content"
                            >
                              <el-input
                                placeholder="请输入证件名称或尺寸搜索"
                                size="medium"
                                v-model="searchText"
                                class="searchInput"
                                @input="handleSearch"
                              >
                                <i slot="prefix" class="el-input__icon el-icon-search" style="color: #46536e"></i>
                              </el-input>
                              <div class="tags" v-if="!isSearchMode">
                                <div
                                  :class="{ tag: true, active: currentTag === it.id }"
                                  v-for="it in CERTIFICATE_LIST"
                                  :key="it.id"
                                  @click="onSelectSizeTag(it.id)"
                                >
                                  {{ it.tag }}
                                </div>
                              </div>
                              <div class="results no-scroller">
                                <div class="certificateSizeList" v-if="searchResults.length">
                                  <div
                                    :class="{
                                      certificate_size_item: true
                                      // active: it.pxSize[0] === width && it.pxSize[1] === height
                                    }"
                                    v-for="(it, idx) in searchResults"
                                    :key="idx"
                                    @click="setSize(it.pxSize[0], it.pxSize[1])"
                                  >
                                    <span class="title">{{ it.title }}</span>
                                    <div class="size_txt">
                                      <span>{{ it.mmSize[0] }}*{{ it.mmSize[1] }}mm</span>
                                      <span>{{ it.pxSize[0] }}*{{ it.pxSize[1] }}px</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="noneBox" v-else>
                                  <img src="@/assets/img/none.svg" alt="" class="noneImg" />
                                  <p class="tips">没有找到相关结果， 可以去自定义尺寸哦～</p>
                                </div>
                              </div>
                            </div>
                            <!--                              <div-->
                            <!--                                      v-else-if="this.currentSizeTab === CHANGE_SIZE_TAB.EC"-->
                            <!--                                      class="change_size_tab_content ec_tab_content"-->
                            <!--                              >-->
                            <!--                                <div class="ec_size_list">-->
                            <!--                                  <div-->
                            <!--                                          class="ec_size_item"-->
                            <!--                                          v-for="(item, idx) in EC_SIZE_LIST"-->
                            <!--                                          :key="idx"-->
                            <!--                                          @click="setSize(item.width, item.height)"-->
                            <!--                                  >-->
                            <!--                                    <span>{{ item.title }}</span>-->
                            <!--                                    <span class="size_txt">{{ item.width }}*{{ item.height }}px</span>-->
                            <!--                                  </div>-->
                            <!--                                </div>-->
                            <!--                              </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="controlContainer">
                <div class="paramsSettingBox">
                  <div class="paramItem">
                    <span class="label">导出格式：</span>
                    <el-radio-group v-model="options.format" class="groups">
                      <el-radio label="jpg">JPG</el-radio>
                      <el-radio label="jpeg">JPEG</el-radio>
                      <el-radio label="png">PNG</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btnGroups">
                    <button class="previewBtn" @click="handlePreview">预览</button>
                    <button class="startBtn" @click="handleDownload">下载</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PreviewModal :dialog-visible="visible" :file-info="fileInfo" @onClose="handleClosePreview" />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import UploadFile from '@/components/UploadFile/index.vue'
import AsideNav from '@/components/AsideNav/index.vue'
import { headerMenus } from '../../config/menus.config'
import { mapActions, mapGetters, mapState } from 'vuex'
import { duce } from '@/api'
import { Message } from 'element-ui'
import { formatTypes } from '../../config'
import { IMG_EDIT_PAGE_CONFIG } from '@/config/page.config'
import { getToken } from '@/utils/token'
import { inToPx, mmToPx, pxToIn, pxToMm } from '@/utils/pxielConversion'
import { uniqBy } from 'lodash-es'
import Cropper from 'cropperjs'
import getImageFileInfo from '@/utils/getImageFileInfo'
import { saveAs } from 'file-saver'
import PreviewModal2 from '@/components/PreviewModal2/index.vue'
import { createWaterMark } from '@/utils/watermark'
import { changeImgDpi } from '@/core'
import { mixins } from '@/mixin'
import { trackUsageFunc } from '@/utils/track'

const CHANGE_SIZE_TAB = {
  COMMON: 'common',
  CERTIFICATE: 'certificate',
  EC: 'ec'
}
// 电商尺寸列表
export const EC_SIZE_LIST = [
  {
    title: '淘宝',
    width: 800,
    height: 800
  },
  {
    title: '京东',
    width: 500,
    height: 500
  },
  {
    title: '拼多多',
    width: 480,
    height: 480
  },
  {
    title: '唯品会',
    width: 1200,
    height: 1200
  },
  {
    title: '抖音',
    width: 600,
    height: 800
  },
  {
    title: '小红书',
    width: 800,
    height: 800
  },
  {
    title: '阿里巴巴',
    width: 800,
    height: 800
  },
  {
    title: '饿了么',
    width: 480,
    height: 480
  },
  {
    title: '美团',
    width: 600,
    height: 600
  },
  {
    title: '咸鱼',
    width: 800,
    height: 800
  }
]
export const CERTIFICATE_LIST = [
  {
    id: 0,
    tag: '热门',
    values: [
      {
        title: '二寸',
        mmSize: [35, 49],
        pxSize: [413, 579]
      },
      {
        title: '一寸',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '五寸',
        mmSize: [89, 127],
        pxSize: [1051, 1500]
      },
      {
        title: '驾照',
        mmSize: [22, 32],
        pxSize: [259, 377]
      },
      {
        title: '小二寸',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '简历照片',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '入学照',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '社保卡',
        mmSize: [26, 32],
        pxSize: [358, 441]
      },
      {
        title: '小一寸',
        mmSize: [22, 32],
        pxSize: [260, 378]
      },
      {
        title: '学籍照片',
        mmSize: [30, 37],
        pxSize: [358, 441]
      }
    ]
  },
  {
    id: 1,
    tag: '常规',
    values: [
      {
        title: '一寸',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '小一寸',
        mmSize: [22, 32],
        pxSize: [260, 378]
      },
      {
        title: '大一寸',
        mmSize: [33, 48],
        pxSize: [390, 567]
      },
      {
        title: '二寸',
        mmSize: [35, 49],
        pxSize: [413, 579]
      },
      {
        title: '小二寸',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '大二寸',
        mmSize: [35, 53],
        pxSize: [413, 626]
      },
      {
        title: '三寸',
        mmSize: [54, 84],
        pxSize: [637, 992]
      },
      {
        title: '四寸',
        mmSize: [76, 102],
        pxSize: [897, 1204]
      },
      {
        title: '五寸',
        mmSize: [89, 127],
        pxSize: [1051, 1500]
      }
    ]
  },
  {
    id: 2,
    tag: '证件',
    values: [
      {
        title: '美国签证',
        mmSize: [51, 51],
        pxSize: [602, 602]
      },
      {
        title: '日本签证',
        mmSize: [45, 45],
        pxSize: [531, 531]
      },
      {
        title: '越南签证',
        mmSize: [40, 60],
        pxSize: [472, 708]
      },
      {
        title: '入台证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '电子护照',
        mmSize: [33, 48],
        pxSize: [389, 566]
      },
      {
        title: '海外申请护照在线预约',
        mmSize: [33, 48],
        pxSize: [389, 566]
      },
      {
        title: '冰岛签证',
        mmSize: [40, 50],
        pxSize: [472, 590]
      },
      {
        title: '世界通用签证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '港澳通行证',
        mmSize: [33, 48],
        pxSize: [389, 566]
      },

      {
        title: '韩国签证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '泰国签证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '印度签证',
        mmSize: [51, 51],
        pxSize: [602, 602]
      },
      {
        title: '以色列签证',
        mmSize: [51, 51],
        pxSize: [602, 602]
      },
      {
        title: '签证采集',
        mmSize: [30, 40],
        pxSize: [354, 472]
      },
      {
        title: '马来西亚签证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '新西兰签证',
        mmSize: [76, 102],
        pxSize: [897, 1204]
      },
      {
        title: '意大利签证',
        mmSize: [35, 40],
        pxSize: [413, 472]
      },
      {
        title: '阿根廷签证',
        mmSize: [40, 40],
        pxSize: [472, 472]
      },
      {
        title: '巴西签证',
        mmSize: [40, 50],
        pxSize: [472, 590]
      },
      {
        title: '肯尼亚签证',
        mmSize: [50, 50],
        pxSize: [590, 590]
      },
      {
        title: '入金证',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '导游证',
        mmSize: [24, 33],
        pxSize: [285, 385]
      },
      {
        title: '教师资格证',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '入学照',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '国考',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '国家司法考试',
        mmSize: [35, 53],
        pxSize: [413, 626]
      },
      {
        title: '二级建造师照片',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '一级建造师证',
        mmSize: [40, 53],
        pxSize: [472, 630]
      },
      {
        title: '二级建造师证',
        mmSize: [39, 56],
        pxSize: [455, 661]
      },
      {
        title: '职业兽医资格证',
        mmSize: [19, 28],
        pxSize: [230, 334]
      },
      {
        title: '自考证件照',
        mmSize: [33, 43],
        pxSize: [384, 512]
      },
      {
        title: '成人自考',
        mmSize: [25, 35],
        pxSize: [294, 413]
      },
      {
        title: '会计从业资格证',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '英语四六级考试',
        mmSize: [33, 48],
        pxSize: [144, 192]
      },
      {
        title: '学位英语',
        mmSize: [33, 48],
        pxSize: [390, 567]
      },
      {
        title: '英语AB级考试',
        mmSize: [33, 48],
        pxSize: [390, 567]
      },
      {
        title: '普通话水平测试',
        mmSize: [33, 48],
        pxSize: [390, 567]
      },
      {
        title: '执业药师考试',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '执业药师资格考试',
        mmSize: [35, 49],
        pxSize: [413, 579]
      },
      {
        title: '执业医师资格报名',
        mmSize: [30, 40],
        pxSize: [354, 472]
      },
      {
        title: '学籍照片',
        mmSize: [30, 37],
        pxSize: [358, 441]
      },
      {
        title: '入学报名',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '大学入学',
        mmSize: [35, 45],
        pxSize: [413, 531]
      },
      {
        title: '高考报名',
        mmSize: [36, 47],
        pxSize: [420, 560]
      },
      {
        title: '全国计算机考试',
        mmSize: [48, 68],
        pxSize: [571, 800]
      },
      {
        title: '护士执业资格考试',
        mmSize: [18, 23],
        pxSize: [210, 276]
      },
      {
        title: '成人自考本科',
        mmSize: [41, 61],
        pxSize: [480, 720]
      },
      {
        title: '自考学位外语考试',
        mmSize: [33, 48],
        pxSize: [390, 567]
      },
      {
        title: '英语三级考试',
        mmSize: [33, 48],
        pxSize: [144, 192]
      },
      {
        title: '西藏二级建造师',
        mmSize: [39, 56],
        pxSize: [455, 661]
      },
      {
        title: '国家公务员考试',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '保险职业认证',
        mmSize: [18, 23],
        pxSize: [210, 270]
      },
      {
        title: '注册会计师',
        mmSize: [15, 19],
        pxSize: [178, 220]
      },
      {
        title: '保险职业证',
        mmSize: [18, 31],
        pxSize: [210, 370]
      },

      {
        title: '居住证',
        mmSize: [26, 32],
        pxSize: [307, 377]
      },
      {
        title: '社保卡',
        mmSize: [26, 32],
        pxSize: [358, 441]
      },
      {
        title: '驾照',
        mmSize: [22, 32],
        pxSize: [259, 377]
      },
      {
        title: '简历照片',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '医保证',
        mmSize: [26, 32],
        pxSize: [358, 441]
      },
      {
        title: '健康证',
        mmSize: [25, 35],
        pxSize: [295, 413]
      },
      {
        title: '执法证',
        mmSize: [22, 30],
        pxSize: [265, 351]
      },
      {
        title: '校园卡',
        mmSize: [20, 27],
        pxSize: [240, 320]
      }
    ]
  }
]
export default {
  name: 'editSize',
  metaInfo() {
    return {
      ...this.tdk
    }
  },
  mixins: [mixins],
  components: {
    PreviewModal: PreviewModal2,
    AsideNav,
    UploadFile,
    DefaultLayout
  },
  data() {
    return {
      tdk: {},
      accept: '.png,.jpg,.jpeg,.bmp,.gif,.webp',
      limit: 1,
      menus: [],
      stepsAreaTitle: IMG_EDIT_PAGE_CONFIG.STEP_TITLE,
      steps: IMG_EDIT_PAGE_CONFIG.STEPS,
      featuresAreaTitle: IMG_EDIT_PAGE_CONFIG.FEATURES_TITLE,
      features: IMG_EDIT_PAGE_CONFIG.FEATURES,
      pageTitle: '',
      isShowExceedDownloadTips: false,
      visible: false, // 预览弹窗的显示与隐藏
      files: [], // 文件列表
      fileInfo: {}, // 当前预览的文件
      options: {
        format: 'png'
      },
      showConfirmBtn: false, // 是否展示确认按钮
      lock: true,
      downloadFiles: [],
      allDownloading: false, // 允许下载
      isExecute: false, // 判断是否执行过

      file: {}, // 当前处理的文件对象

      CHANGE_SIZE_TAB,
      CERTIFICATE_LIST,
      EC_SIZE_LIST,
      currentSizeTab: CHANGE_SIZE_TAB.COMMON, // 调整尺寸当前选中的tab
      searchText: '', // 搜索文字
      isSearchMode: false, // 是否是搜索模式
      searchResults: [],
      editor: null,
      width: 0,
      height: 0,
      currentWidth: 0, // 当前设置的宽度
      currentHeight: 0, // 当前设置的高度
      currentTag: 0,
      unit: 'px',
      ratio: 'origin'
    }
  },

  computed: {
    ...mapGetters(['isVip']),
    ...mapState({
      allCert: state => state.allCert
    })
  },
  watch: {
    // 监听路由变化
    $route: {
      handler(val) {
        this.onRouterChange(val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['setCanFreeDownloadFiles', 'setHistoryDownloads', 'resetHistoryDownloads']),
    // 路由变化时执行
    async onRouterChange(route) {
      if (this.$route.path.indexOf('/edit') != -1) {
        let asideMenus = headerMenus.filter(item => item.key === 'edit')
        if (asideMenus.length !== 0) {
          this.menus = asideMenus[0]?.children
        }
      }

      const { accept, pageTitle, limit, tdk } = route.meta
      this.tdk = {
        title: tdk?.title,
        meta: [
          {
            name: 'keywords',
            content: tdk?.keywords
          },
          {
            name: 'description',
            content: tdk?.description
          }
        ]
      }
      this.accept = accept
      this.limit = limit
      this.pageTitle = pageTitle
      this.resetData()
    },
    // 移除文件
    onRemoveFile(idx) {
      this.files.splice(idx, 1)
      if (this.files.length === 0) {
        this.resetData()
      }
    },
    // 打开预览弹窗
    async handlePreview() {
      this.cropper.getCroppedCanvas().toBlob(async blob => {
        let blobData = await this.createImg({
          src: URL.createObjectURL(blob),
          width: this.width,
          height: this.height,
          dx: 0,
          dy: 0,
          type: this.options.format === 'png' ? 'image/png' : 'image/jpeg'
        })
        let fileInfo = await getImageFileInfo(blobData)
        fileInfo.src = await createWaterMark(fileInfo.src)
        this.file.origin = this.file
        this.file.target = fileInfo
        this.fileInfo = this.file
        this.visible = true
      })
      // this.fileInfo = fileInfo
      // this.visible = true
    },
    // 关闭预览弹窗
    handleClosePreview() {
      this.visible = false
    },
    // 检查是否允许下载
    async checkAllowDownload() {
      // 检查是否登录
      if (!getToken()) {
        this.$Login()
        return false
      }
      await this.$store.dispatch('updateUserInfo')
      // 检查用户是否是vip
      if (!this.isVip) {
        this.$_mixin_showPurchaseModal()
        return false
      }
      return true
    },
    // 上传文件超出数量限制
    onUploadExceed() {
      this.$Msg({
        showLeft: false,
        rightBtnTxt: '知道了',
        content: `单次上传文件不得超过${this.limit}个`
      })
    },
    // 重新上传
    handleReUpload() {
      this.resetData()
    },

    // 重置数据
    resetData() {
      this.files = [] // 文件列表
      this.fileInfo = {} // 当前预览的文件
      this.options = {
        format: 'png'
      }
      this.showConfirmBtn = false // 是否展示确认按钮
      this.lock = true
      this.downloadFiles = []
      this.allDownloading = false // 允许下载
      this.isExecute = false // 判断是否执行过
      this.file = {} // 当前处理的文件对象
      this.currentSizeTab = CHANGE_SIZE_TAB.COMMON // 调整尺寸当前选中的tab
      this.searchText = '' // 搜索文字
      this.isSearchMode = false // 是否是搜索模式
      this.searchResults = []
      this.width = 0
      this.height = 0
      this.currentWidth = 0 // 当前设置的宽度
      this.currentHeight = 0 // 当前设置的高度
      this.currentTag = 0
      this.unit = 'px'
      this.ratio = 'origin'
    },
    async onUploadSuccess(file) {
      let supportTypes = []
      let suffixArray = this.accept.split(',')
      suffixArray.forEach(item => {
        let format = item.split('.')[1]
        supportTypes.push(formatTypes[format])
      })
      if (!supportTypes.includes(file.type)) {
        Message({
          type: 'error',
          message: '请上传指定的格式！'
        })
        return
      }
      if (file.size < 100 * 1024 * 1024) {
        this.files.push({
          raw: file,
          options: this.options
        })

        this.file = await getImageFileInfo(file)
        // console.log(this.file.suffix, '--file')
        this.options.format = this.file.suffix
        let that = this
        this.currentWidth = this.file.width
        this.currentHeight = this.file.height
        this.setRatio(0, 0, 'origin')
        this.setPixelUnit(this.unit)
        this.$nextTick(() => {
          this.cropper = this.createCropper({
            aspectRatio: that.file.width / that.file.height,
            crop(e) {}
          })
        })
      } else {
        this.$Msg({
          showLeft: false,
          rightBtnTxt: '知道了',
          content: `单个文件大小不得超过100MB`
        })
      }
    },

    // 手动输入尺寸
    handleChangeSize() {
      this.ratio = 'free'
      this.showConfirmBtn = true
    },
    // 监听输入宽度
    handleChangeWidth(e) {
      if (this.lock) {
        const ratio = this.currentWidth / this.currentHeight
        this.height = Math.floor(this.width / ratio)
      }
    },
    // 监听输入高度
    handleChangeHeight(e) {
      if (this.lock) {
        const ratio = this.currentWidth / this.currentHeight
        this.width = Math.floor(this.height * ratio)
      }
    },
    /**
     * @description 设置像素单位
     * @param unit 单位：px、in、mm
     */
    setPixelUnit(unit) {
      switch (unit) {
        case 'px':
          this.width = this.currentWidth
          this.height = this.currentHeight
          break
        case 'mm':
          this.width = Math.ceil(pxToMm(this.currentWidth))
          this.height = Math.ceil(pxToMm(this.currentHeight))
          break
        case 'in':
          this.width = Math.ceil(pxToIn(this.currentWidth))
          this.height = Math.ceil(pxToIn(this.currentHeight))
          break
      }
      this.unit = unit
    },
    setLock(status) {
      this.lock = status
    },
    /**
     * 选择比例，规则按照原始文件大小进行计算
     * @param w
     * @param h
     * @param type
     */
    setRatio(w, h, type) {
      this.showConfirmBtn = false
      this.lock = true
      this.ratio = type
      const whiteSpace = ['free', 'origin', 'crop_to_edge']
      let that = this
      let width = this.file.width
      let height = this.file.height
      let crop = () => {}
      if (whiteSpace.includes(type)) {
        this.currentWidth = width
        this.currentHeight = height
      } else {
        this.currentWidth = width
        this.currentHeight = Math.floor((width * h) / w)
      }

      if (type === 'crop_to_edge') {
        this.cropper = this.createCropper({
          cropBoxMovable: false,
          cropBoxResizable: false,
          wheelZoomRatio: false,
          zoomOnWheel: false,
          zoomOnTouch: false,
          zoomable: false
        })
      } else {
        if (type === 'free') {
          crop = e => {
            that.currentWidth = Math.floor(e.detail.width)
            that.currentHeight = Math.floor(e.detail.height)
            that.setPixelUnit(that.unit)
          }
        }
        this.cropper = this.createCropper({
          aspectRatio: type === 'free' ? Number(undefined) : that.currentWidth / that.currentHeight,
          crop
        })
      }

      this.setPixelUnit(this.unit)
    },
    // 点击选择尺寸
    setSize(width, height) {
      this.showConfirmBtn = false
      this.lock = true
      this.currentWidth = width
      this.currentHeight = height
      this.cropper = this.createCropper({
        aspectRatio: width / height,
        crop: e => {}
      })
      this.setPixelUnit(this.unit)
    },

    // 点击确定或者取消
    handleConfirm(type) {
      if (type === 'cancel') {
        this.width = this.currentWidth
        this.height = this.currentHeight
        this.setPixelUnit(this.unit)
      } else if (type === 'confirm') {
        if (this.unit === 'px') {
          this.setSize(this.width, this.height)
        } else if (this.unit === 'mm') {
          this.currentWidth = Math.floor(mmToPx(this.width))
          this.currentHeight = Math.floor(mmToPx(this.height))
        } else if (this.unit === 'in') {
          this.currentWidth = Math.floor(inToPx(this.width))
          this.currentHeight = Math.floor(inToPx(this.height))
        }
      }
      this.showConfirmBtn = false
      this.lock = true
    },
    /**
     * @description 选择尺寸类别
     * @param tagId
     */
    onSelectSizeTag(tagId) {
      this.isSearchMode = false
      this.currentTag = tagId

      let filterData = this.CERTIFICATE_LIST.filter(item => item.id === tagId)
      if (filterData.length) {
        this.searchResults = filterData[0].values
      }
    },
    /**
     * @description 切换选择 常规｜证件｜热门
     * @param tab
     */
    changeSizeTab(tab) {
      this.currentSizeTab = tab
      if (tab === CHANGE_SIZE_TAB.CERTIFICATE) {
        this.searchText = ''
        this.onSelectSizeTag(0)
      }
    },
    /**
     * @description 搜索证件名称｜尺寸
     */
    handleSearch(value) {
      this.isSearchMode = !!value
      if (this.isSearchMode) {
        let all = []
        this.CERTIFICATE_LIST.forEach(item => {
          all.push(...item.values)
        })
        let results = all.filter(item => {
          return (
            item.title.indexOf(value) !== -1 ||
            item.mmSize.includes(Number(value)) ||
            item.pxSize.includes(Number(value))
          )
        })
        results = uniqBy(results, 'title')
        this.searchResults = results
      } else {
        this.onSelectSizeTag(0)
      }
    },
    createCropper(options = {}) {
      this.cropper?.destroy()
      if (this.$refs.cropperRef) {
        return new Cropper(this.$refs.cropperRef, {
          viewMode: 1,
          // viewMode: 0,
          dragMode: 'move',
          center: false,
          zoomable: true, // 禁止用户缩放
          zoomOnTouch: true,
          zoomOnWheel: true,
          cropBoxResizable: true, // 允许改变尺寸
          autoCropArea: 1,
          minCropBoxWidth: 1,
          minCropBoxHeight: 1,
          crop(e) {},
          ...options
        })
      }
    },
    onLeave(e) {
      e.preventDefault()
      return '图片还未处理或下载，是否要离开？'
    },
    createImg(options) {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        canvas.width = options.width
        canvas.height = options.height

        let img = new Image()
        img.src = options.src
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          ctx.drawImage(img, options.dx, options.dy, Number(options.width) + 1, Number(options.height) + 1)
          canvas.toBlob(
            blob => {
              resolve(blob)
            },
            options.type || 'image/jpeg',
            1
          )
        }
        img.onerror = () => {
          reject()
        }
      })
    },
    async handleDownload() {
      if (this.cropper) {
        trackUsageFunc(this.$route.name, this.$route.meta?.pageTitle)
        let flag = this.file.isDownload || (await this.checkAllowDownload())
        if (flag) {
          this.cropper.getCroppedCanvas().toBlob(async blob => {
            let blobData = await this.createImg({
              src: URL.createObjectURL(blob),
              width: this.width,
              height: this.height,
              dx: 0,
              dy: 0,
              type: this.options.format === 'png' ? 'image/png' : 'image/jpeg'
            })
            blobData = await changeImgDpi(blobData, { dpi: 300 })
            if (!this.file.isDownload) {
              duce(1).then(res => {
                if (res.data.status === 0) {
                  this.file.isDownload = true
                  saveAs(blobData, `${this.file.filename}.${this.options.format}`)
                } else {
                  this.$_mixin_showPurchaseModal()
                }
              })
            } else {
              saveAs(blobData, `${this.file.filename}.${this.options.format}`)
            }
            await this.$store.dispatch('updateUserInfo')
          })
        }
      }
    }
  },
  async created() {
    await this.onRouterChange(this.$route)
  },
  async mounted() {
    let that = this
    this.cropper = this.createCropper({
      crop(e) {
        that.options.width = Math.floor(e.detail.width)
        that.options.height = Math.floor(e.detail.height)
      }
    })

    window.addEventListener('beforeunload', e => this.onLeave(e))
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', e => this.onLeave(e))
  }
}
</script>
<style scoped lang="less">
@import url('./Edit.less');
</style>
